module.exports = __webpack_public_path__ + "img/UBank45.db373619.png";